import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import ChangePasswordBody from './body.tsx';
import ChangePasswordHeader from './header.tsx';

const ChangePassword = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoggedIn)
            navigate("/journal");
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn)
        return null;

    return (
        <>
            <ChangePasswordHeader />
            <ChangePasswordBody />
        </>
    );
};

export default ChangePassword;
